import React, { useState, useEffect, useRef } from 'react';
// import { Element } from 'react-scroll';
import { useSwipeable } from 'react-swipeable';

import ScrollInfo from '../UI/ScrollInfo/ScrollInfo';
import classes from './Discover.module.scss';

import bg from '../../assets/images/bg-discover.svg';
import bg2 from '../../assets/images/bg-discover-2.svg';
import img from '../../assets/images/profile-2.png';
import img2 from '../../assets/images/profile-2-hover.png';
import DiscoverVideos from './DiscoverVideos/DiscoverVideos';

// const maskMinSize = window.innerWidth * 0.06;

const Discover = ({ maskSize, setMaskSize, isMobile, ratio  }) => {
  // const maskMinSize = window.innerWidth * 0.06;
  // const maskMaxSize = window.innerWidth * 0.2;
  const maskMinSize = Math.max(window.innerWidth * 0.06 * ratio, 80 * ratio);
  const maskMaxSize = Math.min(window.innerWidth * 0.3, 400);

  const [transX, setTransX] = useState(0);
  const [mousePos, setMousePos] = useState([0, 0]);
  const [btnHover, setBtnHover] = useState(false);
  // const [maskSize, setMaskSize] = useState(maskMaxSize);
  const maskRef = useRef();
  const swipeHandler = useSwipeable({
    onSwipedLeft: ()=> swipePanel(true),
    onSwipedRight: ()=> swipePanel()
  });

  const btnClasses = [classes.Button, 'btn', btnHover ? 'hover' : ''];

  useEffect(()=> {
    let moveTimeout = true;
    const mouseMoveHandler = (e)=> {
      if (moveTimeout) {
        // const target = maskRef.current;
        const rect = maskRef.current ? maskRef.current.getBoundingClientRect() : {top:0};
        const x = e.pageX;
        const y = e.clientY - rect.top;
        setMousePos([x, y]);

        moveTimeout = false;
        setTimeout(()=> moveTimeout = true, 100);
      }
    }
    !isMobile && document.documentElement.addEventListener('mousemove', mouseMoveHandler);
    
    // setMaskSize(maskMaxSize);

    return ()=> document.documentElement.removeEventListener('mousemove', mouseMoveHandler);
  }, [isMobile]);

  useEffect(()=> {
    if (transX > 50) {
      document.body.classList.add('scrollable');
      document.body.style = 'overflow: hidden';
    } 
    else {
      document.body.classList.remove('scrollable');
      document.body.style = 'overflow: auto';
    } 
  }, [transX]);

  const swipePanel = (right) => {
    if (right && transX < 50) {
      setTransX(100);
    }
    else if (!right && transX > 50) {
      setTransX(0);
    }
  }

  return (
    <div className={classes.Discover} ref={maskRef} {...swipeHandler} style={{
      backgroundImage: `url(${bg})`,
      // transform: `translateX(-50%)`
    }}>
      
      <ScrollInfo small={isMobile} parentClass={classes.Discover} 
        color={transX <= 0 ? "#F2F2F2" : '#070707'}
        clicked={transX > 50 ? ()=> swipePanel() : null}  
      >
        {transX < 50 ? "Filmmaking" : "Go back to main page"}
      </ScrollInfo>
      {/* { !isMobile &&
      } */}

      { !isMobile &&

        <div className={classes.Mask} style={{
          backgroundImage: `url(${bg2})`,
          clipPath: `circle(${maskSize}px at ${mousePos[0]}px ${mousePos[1]}px)`,
          transform: `translateX(-${transX}%)`
        }}>

          <div className={classes.Contents}>
            <img src={img2} alt="IMG" className={classes.Image}/>

            <div className={classes.TextContents}>
              <h1 className={[classes.Text, classes.Text1].join(' ')}>& sometimes</h1>
              <h1 className={[classes.Text, classes.Text1].join(' ')}>Cinematography</h1>
            </div>
            
            <button className={btnClasses.join(' ')}
              onMouseEnter={()=> {
                setMaskSize(maskMaxSize * 0.6);
                setBtnHover(true);
              }}
              onMouseLeave={()=> {
                setMaskSize(maskMinSize);
                setBtnHover(false)
              }}
              onClick={()=> swipePanel(true)}
            >
                <p className={classes.Text}>Turn page to Discover</p>
                <div className={classes.Arrow}>
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10.16 16.36"
                  >
                    <g id="Layer_2" data-name="Layer 2">
                      <g id="Layer_1-2" data-name="Layer 1">
                        <polygon points="1.36 16.36 0 14.89 7.22 8.18 0 1.46 1.36 0 10.16 8.18 1.36 16.36"/>
                      </g>
                    </g>
                  </svg>
                </div>
              </button>
          </div>
          
        </div>
      }

      <div className={classes.Contents} style={{
        transform: `translateX(-${transX}%)`
      }}>
        <img src={img} alt="IMG" className={classes.Image}/>

        <div className={classes.TextContents}>
          <h1 className={[classes.Text, classes.Text1].join(' ')}>Film</h1>
          <h1 className={[classes.Text, classes.Text1].join(' ')}>Direction</h1>
        </div>
        
        <button className={btnClasses.join(' ')}
          onClick={()=> swipePanel(true)}
        >
            <p className={classes.Text}>Turn page to Discover</p>
            <div className={classes.Arrow}>
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10.16 16.36"
              >
                <g id="Layer_2" data-name="Layer 2">
                  <g id="Layer_1-2" data-name="Layer 1">
                    <polygon points="1.36 16.36 0 14.89 7.22 8.18 0 1.46 1.36 0 10.16 8.18 1.36 16.36"/>
                  </g>
                </g>
              </svg>
            </div>
          </button>
      </div>

      <DiscoverVideos onBack={()=> swipePanel(false)} style={{ transform: `translateX(-${transX}%)` }} />
    </div>
  );
}

export default Discover;